'use client';

import { useEffect, useState } from 'react';

import {
  asideNavItem,
  asideNavItemLink,
  asideNavItems,
} from '@/app/[locale]/(new)/(public)/projects/[slug]/_page.css';

export function ProjectNavigation() {
  const [titles, setTitles] = useState<[string, string][]>([]);

  useEffect(() => {
    if (document) {
      setTitles(
        Array.from(document.querySelectorAll('h2')).flatMap((elem) => {
          // `Element.checkVisibility()` is unsupported on Safari < 17.4 (and
          // other older browsers); calling it there throws and crashes the page.
          // Feature-detect and fall back to an offsetParent check (null when the
          // element or an ancestor is `display:none`).
          const isVisible =
            typeof elem.checkVisibility === 'function'
              ? elem.checkVisibility()
              : elem.offsetParent !== null;

          if (!isVisible) {
            return [];
          }

          const id = elem.parentElement?.id;

          if (id === undefined) {
            return [];
          }

          return [[id, elem.dataset['short'] ?? elem.innerText]];
        }),
      );
    }
  }, []);

  if (titles.length === 0) {
    return null;
  }

  return (
    <ul className={asideNavItems}>
      {titles.map(([id, title]) => (
        <li className={asideNavItem} key={id}>
          <a className={asideNavItemLink} href={`#${id}`}>
            {title}
          </a>
        </li>
      ))}
    </ul>
  );
}
